import { Language } from '../../utils/i18n.utils';

export const ssoIdentityProviderLinks = {
  // only available in english right now, but there will be different links in the future
  [Language.Default]:
    'https://www.bitdefender.com/business/support/en/77209-80050-configure-gravityzone-cloud-single-sign-on-using-a-3rd-party-identity-provider.html',
};
